import * as types from "../actions/actionTypes";
import intialState from "./initialState";

const handles = {
  [types.ADMIN_COMMUNICATIONS_FETCH_STARTED]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),

  [types.ADMIN_COMMUNICATIONS_FETCH_FULFILLED]: (state, payload) => ({
    ...state,
    loading: false,
    error: null,
    communications: payload.communications || [],
    persons: payload.persons || {},
    pagination: {
      page: payload.page || 1,
      limit: payload.limit || 50,
      total: payload.total || 0,
      totalPages: payload.totalPages || 0,
    },
  }),

  [types.ADMIN_COMMUNICATIONS_FETCH_REJECTED]: (state, error) => ({
    ...state,
    loading: false,
    error,
    communications: [],
    persons: {},
    pagination: {
      page: 1,
      limit: 50,
      total: 0,
      totalPages: 0,
    },
  }),

  [types.ADMIN_COMMUNICATIONS_SELECT]: (state, communicationId) => ({
    ...state,
    selectedId: communicationId,
  }),

  [types.ADMIN_COMMUNICATIONS_SET_FILTERS]: (state, filters) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
  }),

  [types.ADMIN_COMMUNICATIONS_CLEAR_FILTERS]: (state) => ({
    ...state,
    filters: {},
  }),
};

export default function adminCommunicationsReducer(
  state = intialState.adminCommunications,
  action,
) {
  const handler = handles[action.type];
  return handler ? handler(state, action.payload) : state;
}
